// import React, { useEffect, useState } from "react";
// import { useSelector, useDispatch } from "react-redux";
// import * as XLSX from "xlsx";
// import useApi from "../../../CustomHooks/useApi";
// import { Search, Download, Printer } from "lucide-react";
// import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";
// import { openPrint } from "../../../Store/Slices/printSlice";
// import PrintPopup from "../../../ResuableCompoment/PrintPopup";
// import DynamicTable from "../../../ResuableCompoment/DynamicTable";

// const PPITransaction = () => {
//   const mid = useSelector(
//     (state) => state.auth.employeeDetails?.username
//   );
//   const dispatch = useDispatch();

//   const { callApi: ppiApi } = useApi(
//     "/payout/history",
//     "GET"
//   );

//   /* ================= STATES ================= */
//   const [history, setHistory] = useState([]);
//   const [isHistoryLoading, setIsHistoryLoading] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const recordsPerPage = 25;
//   const [searchTerm, setSearchTerm] = useState("");

//   const getToday = () => new Date().toISOString().split("T")[0];

//   const [fromDate, setFromDate] = useState(getToday());
//   const [toDate, setToDate] = useState(getToday());

//   /* ================= TABLE COLUMNS ================= */
//   const columns = [
//     {
//       key: "date",
//       label: "Date",
//       render: (v) => getDisplayDate(v),
//     },
//     {
//       key: "txnId",
//       label: "Txn ID",
//     },
//     {
//       key: "amount",
//       label: "Amount",
//       render: (v) => (
//         <span className="font-semibold text-slate-800">
//           ₹{Number(v || 0).toFixed(2)}
//         </span>
//       ),
//     },
//     {
//       key: "beneficiary_name",
//       label: "Beneficiary Name",
//       render: (v) => (
//         <div className="max-w-xs whitespace-normal break-words">
//           {v || "—"}
//         </div>
//       ),
//     },
//     {
//       key: "beneficiary_account_number",
//       label: "Account No",
//     },
//     {
//       key: "beneficiary_ifsc_code",
//       label: "IFSC",
//     },
//     {
//       key: "status",
//       label: "Status",
//       render: (v) => (
//         <span
//           className={`inline-flex items-center px-3 py-1 rounded-full
//             text-xs font-semibold
//             ${v === "SUCCESS"
//               ? "bg-emerald-100 text-emerald-700"
//               : v === "PENDING"
//                 ? "bg-amber-100 text-amber-700"
//                 : "bg-rose-100 text-rose-700"
//             }`}
//         >
//           {v}
//         </span>
//       ),
//     },
//     {
//       key: "action",
//       label: "Action",
//       render: (_, row) => (
//         <button
//           onClick={() => dispatch(openPrint(row))}
//           className="inline-flex items-center gap-1.5
//                      px-3 py-1.5 rounded-lg
//                      text-xs font-semibold
//                      bg-indigo-50 text-indigo-700
//                      hover:bg-indigo-100"
//         >
//           <Printer size={14} />
//           Print
//         </button>
//       ),
//     },
//   ];

//   /* ================= FETCH HISTORY ================= */
//   const fetchHistory = async () => {
//     setIsHistoryLoading(true);
//     try {
//       let query = `?merchant_user_name=${mid}&paymentMode=PPI`;

//       if (fromDate) query += `&fromDate=${fromDate}`;
//       if (toDate) query += `&toDate=${toDate}`;

//       const res = await ppiApi(null, query);
//       const sorted = (res || []).sort(
//         (a, b) => new Date(b.date) - new Date(a.date)
//       );
//       setHistory(sorted);
//     } catch (err) {
//       console.error(err);
//       alert("Failed to load PPI transaction history");
//     } finally {
//       setIsHistoryLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchHistory();
//     // eslint-disable-next-line
//   }, []);

//   /* ================= SEARCH + PAGINATION ================= */
//   const filteredRecords = history.filter((record) =>
//     Object.values(record).some((value) =>
//       String(value)
//         .toLowerCase()
//         .includes(searchTerm.toLowerCase())
//     )
//   );

//   const totalPages = Math.ceil(
//     filteredRecords.length / recordsPerPage
//   );
//   const indexOfLastRecord = currentPage * recordsPerPage;
//   const indexOfFirstRecord =
//     indexOfLastRecord - recordsPerPage;
//   const currentRecords = filteredRecords.slice(
//     indexOfFirstRecord,
//     indexOfLastRecord
//   );

//   /* ================= EXCEL DOWNLOAD ================= */
//   const downloadExcel = () => {
//     const rows = history.map((r) => ({
//       Date: r.date,
//       TxnID: r.txnId,
//       Amount: r.amount,
//       Beneficiary: r.beneficiary_name,
//       Account: r.beneficiary_account_number,
//       IFSC: r.beneficiary_ifsc_code,
//       Status: r.status,
//     }));

//     const ws = XLSX.utils.json_to_sheet(rows);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "PPI Transactions");
//     XLSX.writeFile(wb, "PPI_Transaction_History.xlsx");
//   };

//   /* ================= UI ================= */
//   return (
//     <div className="min-h-screen p-6 bg-[#EEF1F5]">

//       {/* ================= PAGE TITLE ================= */}
//       <div className="mb-6">
//         <h1 className="text-3xl font-bold text-[#0A2A4F]">
//           PPI Transaction Reports
//         </h1>
//         <p className="text-sm text-gray-600 mt-1">
//           Track Prepaid Instrument (PPI) transfers
//         </p>
//       </div>

//       {/* ================= SEARCH BAR ================= */}
//       <div className="bg-white rounded-2xl shadow-sm border p-6 mb-8">
//         <div className="flex flex-wrap items-center gap-4">

//           {/* 🔍 Search */}
//           <div className="relative w-full md:w-80">
//             <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
//             <input
//               type="text"
//               placeholder="Search by Txn ID, Beneficiary or Status"
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//               className="w-full pl-10 pr-4 h-10 rounded-lg border
//                    focus:border-[#0A2A4F] focus:outline-none"
//             />
//           </div>

//           {/* 📅 From Date */}
//           <input
//             type="date"
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//             className="h-10 px-3 border rounded-lg bg-gray-50"
//           />

//           {/* 📅 To Date */}
//           <input
//             type="date"
//             value={toDate}
//             min={fromDate}
//             onChange={(e) => setToDate(e.target.value)}
//             className="h-10 px-3 border rounded-lg bg-gray-50"
//           />

//           {/* ✅ Apply */}
//           <button
//             onClick={() => {
//               setCurrentPage(1);
//               fetchHistory();
//             }}
//             className="h-10 px-5 rounded-lg bg-indigo-600 text-white font-semibold
//                  hover:bg-indigo-700 transition"
//           >
//             Apply
//           </button>

//           {/* 📥 Download */}
//           <button
//             onClick={downloadExcel}
//             className="h-10 px-6 rounded-lg bg-green-600 text-white font-semibold
//                  shadow hover:bg-green-700 transition flex items-center gap-2"
//           >
//             <Download size={16} />
//             Download Excel
//           </button>

//         </div>
//       </div>
//       {/* ================= TABLE ================= */}
//       {/* <div className="bg-white p-8 rounded-2xl shadow-md"> */}
//       <div className="bg-white rounded-2xl shadow-md">
//         <DynamicTable
//           columns={columns}
//           data={currentRecords}
//           isLoading={isHistoryLoading}
//           emptyText="No PPI records found"
//         />
//       </div>

//       {/* ================= PAGINATION ================= */}
//       {filteredRecords.length > recordsPerPage && (
//         <div className="mt-6 flex flex-wrap items-center justify-between
//                         text-sm text-gray-600">
//           <span>
//             Page <b>{currentPage}</b> of <b>{totalPages}</b>
//           </span>

//           <div className="flex gap-3">
//             <button
//               disabled={currentPage === 1}
//               onClick={() =>
//                 setCurrentPage((p) => p - 1)
//               }
//               className="px-4 py-2 rounded-lg bg-gray-200
//                          text-gray-700 disabled:opacity-50"
//             >
//               Previous
//             </button>

//             <button
//               disabled={currentPage === totalPages}
//               onClick={() =>
//                 setCurrentPage((p) => p + 1)
//               }
//               className="px-4 py-2 rounded-lg bg-[#0A2A4F]
//                          text-white disabled:opacity-50"
//             >
//               Next
//             </button>
//           </div>
//         </div>
//       )}

//       <PrintPopup />
//     </div>
//   );
// };

// export default PPITransaction;




import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as XLSX from "xlsx";
import useApi from "../../../CustomHooks/useApi";
import { 
  Search, 
  FileSpreadsheet, 
  Printer, 
  WalletCards, 
  RotateCw, 
  CheckCircle2, 
  XCircle, 
  Clock, 
  ChevronLeft, 
  ChevronRight 
} from "lucide-react";
import { getDisplayDate } from "../../../ResuableCompoment/GetDisplayDate";
import { openPrint } from "../../../Store/Slices/printSlice";
import PrintPopup from "../../../ResuableCompoment/PrintPopup";
import DynamicTable from "../../../ResuableCompoment/DynamicTable";

const PPITransaction = () => {
  const mid = useSelector((state) => state.auth.employeeDetails?.username);
  const dispatch = useDispatch();

  const { callApi: ppiApi } = useApi(
    "/payout/history",
    "GET"
  );

  /* ================= STATES ================= */
  const [history, setHistory] = useState([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 25;
  const [searchTerm, setSearchTerm] = useState("");

  const getToday = () => new Date().toISOString().split("T")[0];

  const [fromDate, setFromDate] = useState(getToday());
  const [toDate, setToDate] = useState(getToday());

  /* ================= TABLE COLUMNS ================= */
  const columns = [
    {
      key: "date",
      label: "Date",
      render: (v) => getDisplayDate(v),
    },
    {
      key: "txnId",
      label: "Txn ID",
      render: (v) => (
        <span className="font-mono text-slate-700 bg-slate-100/70 px-2 py-0.5 rounded-md border border-slate-200/50">
          {v || "—"}
        </span>
      ),
    },
    {
      key: "amount",
      label: "Amount",
      render: (v) => (
        <span className="font-bold text-slate-900 text-sm">
          ₹{Number(v || 0).toFixed(2)}
        </span>
      ),
    },
    {
      key: "beneficiary_name",
      label: "Beneficiary Name",
      render: (v) => (
        <div className="max-w-xs whitespace-normal break-words font-semibold text-slate-800">
          {v || "—"}
        </div>
      ),
    },
    {
      key: "beneficiary_account_number",
      label: "Account No",
      render: (v) => (
        <span className="font-mono text-slate-600">
          {v || "—"}
        </span>
      ),
    },
    {
      key: "beneficiary_ifsc_code",
      label: "IFSC",
      render: (v) => (
        <span className="font-mono text-slate-500 uppercase">
          {v || "—"}
        </span>
      ),
    },
    {
      key: "status",
      label: "Status",
      render: (v) => {
        const status = (v || "").toUpperCase();
        if (status === "SUCCESS") {
          return (
            <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
              <CheckCircle2 className="w-3 h-3" /> SUCCESS
            </span>
          );
        }
        if (status === "FAILED" || status === "FAILURE") {
          return (
            <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-rose-50 text-rose-700 border border-rose-200">
              <XCircle className="w-3 h-3" /> FAILED
            </span>
          );
        }
        return (
          <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-semibold bg-amber-50 text-amber-700 border border-amber-200">
            <Clock className="w-3 h-3" /> {status || "PENDING"}
          </span>
        );
      },
    },
    {
      key: "action",
      label: "Receipt",
      render: (_, row) => (
        <button
          onClick={() => dispatch(openPrint(row))}
          className="p-1.5 rounded-xl border border-slate-200 text-slate-600 hover:text-blue-600 hover:border-blue-200 bg-white hover:bg-slate-50 transition active:scale-95 inline-flex items-center gap-1 shadow-2xs cursor-pointer"
          title="Print PPI Receipt"
        >
          <Printer className="w-3.5 h-3.5" />
          <span className="text-[11px] font-semibold">Print</span>
        </button>
      ),
    },
  ];

  /* ================= FETCH HISTORY ================= */
  const fetchHistory = async () => {
    setIsHistoryLoading(true);
    try {
      let query = `?merchant_user_name=${mid}&paymentMode=PPI`;

      if (fromDate) query += `&fromDate=${fromDate}`;
      if (toDate) query += `&toDate=${toDate}`;

      const res = await ppiApi(null, query);
      const sorted = (res || []).sort(
        (a, b) => new Date(b.date) - new Date(a.date)
      );
      setHistory(sorted);
      setCurrentPage(1);
    } catch (err) {
      console.error(err);
      // alert("Failed to load PPI transaction history");
      console.log("Failed to load PPI transaction history");
    } finally {
      setIsHistoryLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
    // eslint-disable-next-line
  }, []);

  /* ================= SEARCH + PAGINATION ================= */
  const filteredRecords = history.filter((record) =>
    Object.values(record).some((value) =>
      String(value)
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
    )
  );

  const totalPages = Math.ceil(filteredRecords.length / recordsPerPage) || 1;
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredRecords.slice(
    indexOfFirstRecord,
    indexOfLastRecord
  );

  /* ================= EXCEL DOWNLOAD ================= */
  const downloadExcel = () => {
    const rows = history.map((r) => ({
      Date: r.date,
      TxnID: r.txnId,
      Amount: r.amount,
      Beneficiary: r.beneficiary_name,
      Account: r.beneficiary_account_number,
      IFSC: r.beneficiary_ifsc_code,
      Status: r.status,
    }));

    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "PPI Transactions");
    XLSX.writeFile(wb, "PPI_Transaction_History.xlsx");
  };

  return (
    <div className="space-y-6">
      {/* ================= SECTION HEADER ================= */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700 border border-blue-100 mb-2">
            <WalletCards className="w-3.5 h-3.5" />
            Prepaid Payment Instrument (PPI) Log
          </div>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-800 tracking-tight">
            PPI Transaction Reports
          </h2>
          <p className="text-xs text-slate-500 font-medium mt-0.5">
            Audit wallet card loads, prepaid instrument transfers, and transaction confirmations
          </p>
        </div>
      </div>

      {/* ================= FILTER & SEARCH BAR ================= */}
      <div className="bg-white rounded-3xl p-5 border border-slate-200/80 shadow-xs space-y-4">
        <div className="flex flex-wrap items-center justify-between gap-4">
          
          {/* Search Box */}
          <div className="relative w-full sm:w-80">
            <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Search Txn ID, Beneficiary, Account..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200/80 focus:border-blue-500 focus:bg-white rounded-xl text-xs font-semibold text-slate-700 placeholder-slate-400 outline-hidden transition"
            />
          </div>

          {/* Date Picker & Actions */}
          <div className="flex flex-wrap items-center gap-2.5 w-full sm:w-auto">
            <div className="flex items-center gap-2">
              <input
                type="date"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                className="h-10 px-3 bg-slate-50 border border-slate-200/80 focus:border-blue-500 focus:bg-white rounded-xl text-xs font-semibold text-slate-700 outline-hidden transition"
              />
              <span className="text-slate-400 text-xs font-bold">to</span>
              <input
                type="date"
                value={toDate}
                min={fromDate}
                onChange={(e) => setToDate(e.target.value)}
                className="h-10 px-3 bg-slate-50 border border-slate-200/80 focus:border-blue-500 focus:bg-white rounded-xl text-xs font-semibold text-slate-700 outline-hidden transition"
              />
            </div>

            <button
              onClick={() => {
                setCurrentPage(1);
                fetchHistory();
              }}
              disabled={isHistoryLoading}
              className="h-10 px-4 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-bold text-xs shadow-md shadow-slate-900/10 transition active:scale-95 flex items-center gap-1.5 cursor-pointer"
            >
              <RotateCw className={`w-3.5 h-3.5 ${isHistoryLoading ? "animate-spin" : ""}`} />
              <span>Apply</span>
            </button>

            <button
              onClick={downloadExcel}
              className="h-10 px-4 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs shadow-md shadow-emerald-600/15 transition active:scale-95 flex items-center gap-1.5 cursor-pointer"
            >
              <FileSpreadsheet className="w-3.5 h-3.5" />
              <span>Excel</span>
            </button>
          </div>
        </div>

        {/* Count Preview Bar */}
        <div className="pt-2 border-t border-slate-100 flex items-center justify-between text-xs text-slate-500 font-medium">
          <span>
            Showing <strong className="text-slate-800">{currentRecords.length}</strong> of{" "}
            <strong className="text-slate-800">{filteredRecords.length}</strong> PPI transactions
          </span>
          <span>
            Page <strong className="text-blue-600 font-bold">{currentPage}</strong> of{" "}
            <strong>{totalPages}</strong>
          </span>
        </div>
      </div>

      {/* ================= TABLE CONTAINER ================= */}
      <div className="bg-white rounded-3xl border border-slate-200/80 shadow-xs p-2 sm:p-4">
        <DynamicTable
          columns={columns}
          data={currentRecords}
          isLoading={isHistoryLoading}
          emptyText="No PPI transaction records found for the selected range"
        />

        {/* ================= PAGINATION CONTROLS ================= */}
        {filteredRecords.length > recordsPerPage && (
          <div className="mt-4 pt-3 border-t border-slate-100 flex flex-wrap items-center justify-between gap-4 text-xs font-semibold text-slate-600 px-2">
            <span>
              Page {currentPage} of {totalPages}
            </span>

            <div className="flex items-center gap-2">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((p) => p - 1)}
                className="px-3 py-1.5 rounded-xl border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 disabled:opacity-40 transition active:scale-95 flex items-center gap-1 cursor-pointer"
              >
                <ChevronLeft className="w-3.5 h-3.5" />
                <span>Prev</span>
              </button>

              <button
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage((p) => p + 1)}
                className="px-3 py-1.5 rounded-xl bg-slate-900 hover:bg-slate-800 text-white disabled:opacity-40 transition active:scale-95 flex items-center gap-1 cursor-pointer"
              >
                <span>Next</span>
                <ChevronRight className="w-3.5 h-3.5" />
              </button>
            </div>
          </div>
        )}
      </div>

      <PrintPopup />
    </div>
  );
};

export default PPITransaction;